import type { AxiosInstance } from 'axios';

import { authenticator } from './authenticator';

/**
 * Registers an interceptor for the specified agents to include the Authorization request header in all logged-in user requests.
 *
 * The registered interceptor maintains the behavior of `@creditornot/wolt-auth@^4`, gracefully omitting the Authorization
 * request header if an access token cannot be acquired, typically occurring when the user is logged out.
 */
export function registerAuthInterceptor(...axiosInstances: AxiosInstance[]) {
  for (const instance of axiosInstances) {
    instance.interceptors.request.use(async config => {
      if (authenticator.getState().status === 'logged-in') {
        config.headers.authorization = `Bearer ${await authenticator.getAccessToken()}`;
      }
      return config;
    });
  }
}
